import React from "react";
import { Space } from "antd";
import { AxTextarea, AxDivider, AxButton } from "@dynata/axiom3";

class Textarea extends React.Component {
  render() {
    return (
      <div className="section" id="textarea">
        <h3>Textarea</h3>
        <p>Textarea input.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxTextarea placeholder="AxTextarea" />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/input/#Input.TextArea"
                >
                  https://ant.design/components/input/#Input.TextArea
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Textarea size, default is medium</td>
                  <td>small | medium | large</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>allowClear</td>
                  <td>If allow to remove input content with clear icon</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>autoSize</td>
                  <td>
                    Height autosize feature, can be set to true | false or an
                    object <pre>{`{ minRows: 2, maxRows: 6 }`}</pre>
                  </td>
                  <td>boolean | object</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>bordered</td>
                  <td>Whether has border style</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.5.0</td>
                </tr>
                <tr>
                  <td>defaultValue</td>
                  <td>The initial input content</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>maxLength</td>
                  <td>The max length</td>
                  <td>number</td>
                  <td>-</td>
                  <td>4.7.0</td>
                </tr>
                <tr>
                  <td>showCount</td>
                  <td>Whether show text count</td>
                  <td>
                    boolean |{" "}
                    <pre>{`{ formatter: (info: { value: string, count: number, maxLength?: number }) =&gt; string }`}</pre>
                  </td>
                  <td>false</td>
                  <td>4.7.0 formatter: 4.10.0 info.value: 4.23.0</td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>The input content value</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onPressEnter</td>
                  <td>
                    The callback function that is triggered when Enter key is
                    pressed
                  </td>
                  <td>function(e)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onResize</td>
                  <td>The callback function that is triggered when resize</td>
                  <td>
                    <pre>{`function({(width, height)})`}</pre>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/input/#Input.TextArea"
                      >
                        {`<Input.TextArea />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxTextarea placeholder="AxTextarea" size="small" />
<AxTextarea placeholder="AxTextarea" />
<AxTextarea placeholder="AxTextarea" size="large" />`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Small | Medium | Large
        </AxDivider>
        <Space direction="vertical" style={{ width: "350px" }}>
          <AxTextarea placeholder="AxTextarea" size="small" />
          <AxTextarea placeholder="AxTextarea" />
          <AxTextarea placeholder="AxTextarea" size="large" />
        </Space>
      </div>
    );
  }
}
export default Textarea;
